import { Link } from "react-router-dom";
import SeriesItem from "./SeriesItem";

export default function ComputerGraphics(){
    return(
        <SeriesItem id = "271afaf7-b684-80ac-af10-e8facb720a89"/>
    )
}